export const useHelpers = () => {
  // Ritorno gli slug per la seo (hreflang etc.) nel formato
  /*
  {
    it: { slug: 'slug-1'},
    en: { slug: 'slug-2'},
    'en-us': { slug: 'slug-3'}
  }
  */
  const generateSeoLocaleParams = (localeParams, param) => {
    const params = isRef(localeParams) ? localeParams : ref(localeParams)

    return params.value.reduce((acc, item) => {
      if (item.language.includes('en'))
        return {
          ...acc,
          en: { [param]: item[param] },
          'en-us': { [param]: item[param] },
        }
      else return { ...acc, it: { [param]: item[param] } }
    }, {})
  }

  return {
    generateSeoLocaleParams,
  }
}
